export const IDLE_RESET_STORAGE_KEY = "idle:lastActivityTs";

let installed = false;

export function installIdleActivityListeners(target?: Window): void {
  const win = target ?? (typeof window !== "undefined" ? window : undefined);
  if (!win || installed) {
    return;
  }

  let storage: Storage | null = null;
  try {
    storage = win.localStorage;
  } catch {
    storage = null;
  }

  if (!storage) {
    return;
  }

  const write = () => {
    try {
      storage.setItem(IDLE_RESET_STORAGE_KEY, String(Date.now()));
    } catch {
      // Swallow storage write failures (private mode, quota exceeded, etc.)
    }
  };

  const events: Array<keyof WindowEventMap> = [
    "click",
    "keydown",
    "mousedown",
    "touchstart",
    "scroll",
  ];

  events.forEach((eventName) => {
    try {
      win.addEventListener(eventName, write, { passive: true });
    } catch {
      // Older browsers may not support passive option; fall back gracefully.
      win.addEventListener(eventName, write as EventListener);
    }
  });

  write();
  installed = true;
}
